/* This file is autogenerated, see readme.md for instructions */
import DescriptionSvgIcon from '@bloomreach/banana-theme/icons/description.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const DescriptionIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <DescriptionSvgIcon />
    </Icon>
  );
});

DescriptionIcon.displayName = 'DescriptionIcon';

export default DescriptionIcon;
